import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center p-2 sm:p-4 overflow-y-auto"
}
const _hoisted_2 = { class: "flex items-center gap-3" }
const _hoisted_3 = { class: "flex flex-col sm:flex-row justify-end items-stretch sm:items-center gap-2 sm:gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.modelValue)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", {
                class: "absolute inset-0 bg-black/60",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
              }),
              _createElementVNode("div", {
                class: _normalizeClass(["relative bg-white dark:bg-slate-800 rounded-xl sm:rounded-2xl w-full shadow-2xl my-4 sm:my-8 max-h-[95vh] sm:max-h-[90vh] flex flex-col overflow-hidden", _ctx.size === 'large' ? 'max-w-4xl' : 'max-w-3xl'])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["px-4 sm:px-6 py-4 sm:py-5 flex-shrink-0", _ctx.headerClasses])
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h3", {
                      class: _normalizeClass(["text-lg sm:text-xl font-bold", _ctx.titleClasses])
                    }, _toDisplayString(_ctx.title), 3)
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["px-4 sm:px-6 py-4 sm:py-6 overflow-y-auto flex-1", _ctx.bodyClasses])
                }, [
                  _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["px-4 sm:px-6 py-3 sm:py-4 flex-shrink-0", _ctx.footerClasses])
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _renderSlot(_ctx.$slots, "footer", {}, () => [
                      _createElementVNode("button", {
                        type: "button",
                        class: "px-4 sm:px-5 py-2.5 text-sm font-semibold text-slate-700 dark:text-slate-300 bg-white dark:bg-slate-700 border border-slate-300 dark:border-slate-600 rounded-xl hover:bg-slate-50 dark:hover:bg-slate-600 transition-all shadow-sm",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                      }, " Cancel ")
                    ], true)
                  ])
                ], 2)
              ], 2)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}